import type { ReactNode } from 'react';
import './athlete-overview-panel.css';

/** Shared expanded-athlete surface; child cards keep their data and interactions. */
export function AthleteOverviewPanel({ children }: { children: ReactNode }) {
  return <div className="coach-athlete-card__body athlete-overview-panel">{children}</div>;
}
